import React, { useState, useEffect } from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Filler } from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, Legend, Tooltip, ArcElement, LinearScale, PointElement, LineElement, Filler)

export default function RelatorioChart(props) {
    const valores = props.valores;
    const [dados, setDados] = useState([]);
    const labels = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    useEffect(() => {
        let totaisMeses = [];
        for (let mes_id = 1; mes_id < 13; mes_id++) {
            let soma = 0.00000000;
            valores.map((valor) => {
                if (valor.mes_id == mes_id) {
                    if (valor.valor) {
                        let floatValor = parseFloat(String(valor.valor).replaceAll('.', '').replaceAll(',', '.'));
                        if (!isNaN(floatValor)) {
                            soma = soma + floatValor;
                        }
                    }
                }
            });
            totaisMeses.push(soma);
        }
        setDados(totaisMeses);
    }, []);

    const options = {
        responsive: true,
        elements: {
            line: {
                tension: 0.3
            }
        },
        plugins: {
            legend: false,
            title: {
                display: false,
                text: 'Chart.js Line Chart',
            },
        },
    };

    const data = {
        labels,
        datasets: [
            {
                label: props.label,
                data: dados,
                borderColor: props.backgroundColor,
                backgroundColor: props.backgroundColor,
            }
        ],
    };

    return (
        <>
            <div className="container-fluid" style={{ marginBottom: '30px', marginTop: '-25px' }}>
                <Line options={options} data={data} height={25} style={{ minHeight: '120px' }} />
            </div>
        </>
    );

}
